import useInitializeColorAdvancedForm from './useInitializeColorAdvancedForm'

export default useInitializeColorAdvancedForm
